"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedCountryCodes = exports.phoneNumberMaxLength = exports.getPhoneNumberInfo = exports.getPhoneLength = exports.getDddLength = exports.dddMaxLength = void 0;
var _constants = require("../containers/constants");
var getPhoneNumberInfo = function getPhoneNumberInfo(phoneNumber) {
  if (!phoneNumber) {
    return {};
  }
  var countryCode = phoneNumber.substring(0, _constants.COUNTRY_CODE_MAX_LENGTH);
  var isSupportedCountryCode = supportedCountryCodes.includes(countryCode.replace("+", ""));
  if (!isSupportedCountryCode) {
    return {};
  }
  var areaCode = phoneNumber.substring(_constants.COUNTRY_CODE_MAX_LENGTH, _constants.COUNTRY_CODE_DDD_MAX_LENGTH);
  return {
    countryCode: countryCode,
    areaCode: areaCode,
    phoneNumber: phoneNumber.substring(_constants.COUNTRY_CODE_DDD_MAX_LENGTH)
  };
};
exports.getPhoneNumberInfo = getPhoneNumberInfo;
var supportedCountryCodes = [_constants.BRAZILIAN_COUNTRY_CODE, _constants.MEXICAN_COUNTRY_CODE];
exports.supportedCountryCodes = supportedCountryCodes;
var phoneNumberMaxLength = {
  BR: 9,
  MX: 8
};
exports.phoneNumberMaxLength = phoneNumberMaxLength;
var dddMaxLength = {
  BR: 2,
  MX: 3
};
exports.dddMaxLength = dddMaxLength;
var getPhoneLength = function getPhoneLength(iso) {
  return phoneNumberMaxLength[iso] || _constants.DEFAULT_MAX_LENGTH;
};
exports.getPhoneLength = getPhoneLength;
var getDddLength = function getDddLength(iso) {
  return dddMaxLength[iso] || _constants.DEFAULT_DDD_MAX_LENGTH;
};
exports.getDddLength = getDddLength;